import dayjs, { Dayjs } from 'dayjs'

export const dateTimeFormat = (date: Dayjs | Date | string) => {
  if (date) {
    return dayjs(date).format('DD/MM/YYYY HH:mm:ss')
  }
  return null
}
